/*
 * @Author: 范向玲
 * @Date: 2022-10-08 16:16:00
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2025-03-06 10:33:46
 * @Description: 数据管理表格配置
 * @FilePath: \web\src\components\DataManagement\logManagement\tableConfig.js
 */
const tableConfig = [
  {
    title: '序号',
    slots: { customRender: 'serial' },
    ellipsis: true,
    width: 60,
    align: 'center',
  },
  {
    title: '操作类型',
    dataIndex: 'operateType',
    ellipsis: true,
    align: 'center',
  },
  // {
  //   title: '用户ID',
  //   dataIndex: 'userid',
  //   ellipsis: true,
  //   align: 'center',
  // },
  {
    title: '用户名',
    dataIndex: 'username',
    ellipsis: true,
    align: 'center',
  },

  {
    title: '用户姓名',
    dataIndex: 'name',
    ellipsis: true,
    align: 'center',
  },
  {
    title: 'IP属地',
    dataIndex: 'ipAddress',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '用户单位',
    dataIndex: 'orgName',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '操作时间',
    dataIndex: 'operateTime',
    ellipsis: true,
    align: 'center',
  },
];

export default tableConfig;
